/**
 * 格式化日期
 * @param fmt "yyyy-MM-dd"/"yyyy-MM-dd HH:mm:ss"
 */
export function formatTime(date, fmt) {
  var o = {
    "M+": date.getMonth() + 1, //月份
    "d+": date.getDate(), //日
    "H+": date.getHours(), //小时
    "m+": date.getMinutes(), //分
    "s+": date.getSeconds(), //秒
    "q+": Math.floor((date.getMonth() + 3) / 3), //季度
    S: date.getMilliseconds(), //毫秒
  };
  if (/(y+)/.test(fmt))
    fmt = fmt.replace(
      RegExp.$1,
      (date.getFullYear() + "").substr(4 - RegExp.$1.length)
    );
  for (var k in o)
    if (new RegExp("(" + k + ")").test(fmt))
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length)
      );
  return fmt;
}

export function getSameDay(a, b) {
  const date1 = new Date(a);
  const date2 = new Date(b);

  return (
    date1.getFullYear() === date2.getFullYear() &&
    date1.getMonth() === date2.getMonth() &&
    date1.getDate() === date2.getDate()
  );
}

export function isUSDaylightSavingTime(data) {
  // 获取美国东部时间（UTC-5）和中国东部时间（UTC+8）的时区偏移量
  const usTZOffset = -5 * 60; // 美国东部时间（UTC-5）的时区偏移量（分钟）
  const chinaTZOffset = 8 * 60; // 中国东部时间（UTC+8）的时区偏移量（分钟）

  // 获取当前时间
  const now = data ? new Date(data) : new Date();
  // 将当前时间转换为美国东部时间
  const usTime = new Date(
    now.getTime() + (usTZOffset - now.getTimezoneOffset()) * 60 * 1000
  );
  usTime.setHours(0, 0, 0, 0);

  // 判断美国东部时间是否在夏令时范围内
  const dstStart = getSecondSundayOfMarch(usTime.getFullYear()); // 第二个星期日的2点
  const dstEnd = getFirstSundayOfNovember(usTime.getFullYear()); // 第一个星期日的2点

  if (usTime >= dstStart && usTime < dstEnd) {
    return true; // 夏令时
  } else {
    return false; // 冬令时
  }
}

function getSecondSundayOfMarch(year) {
  const marchFirst = new Date(year, 2, 1);
  const dayOfWeek = marchFirst.getDay();
  const secondSunday = 1 + ((7 - dayOfWeek) % 7) + 7;
  return new Date(year, 2, secondSunday, 2, 0, 0); // 设置时间为凌晨 2 点
}

function getFirstSundayOfNovember(year) {
  const novemberFirst = new Date(year, 10, 1);
  const dayOfWeek = novemberFirst.getDay();
  const firstSunday = 1 + ((7 - dayOfWeek) % 7);
  return new Date(year, 10, firstSunday, 2, 0, 0); // 设置时间为凌晨 2 点
}

export function getLATime(deleteMin) {
  const now = new Date();

  // 使用 Intl.DateTimeFormat 格式化日期和时间
  const options = {
    timeZone: "America/Los_Angeles",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  };

  const formatter = new Intl.DateTimeFormat("en-US", options);
  const formattedDate = formatter.format(now);

  // 返回时间戳
  return deleteMin
    ? new Date(formattedDate).setMinutes(0, 0, 0)
    : new Date(formattedDate).getTime();
}

export function getDay(date, num = 0) {
  const now = new Date(date);
  const year = now.getFullYear();
  const month = now.getMonth();
  const day = now.getDate();

  return new Date(year, month, day + num, 0, 0, 0, 0).getTime();
}

export function getTimeRange(picker, time, date) {
  const end = date ? new Date(date) : new Date();
  const start = date ? new Date(date) : new Date();
  start.setTime(start.getTime() - 3600 * 1000 * time);
  if (picker) {
    picker.$emit("pick", [start, end]);
  } else {
    return [start.getTime(), end.getTime()];
  }
}

export function getBJTime(time) {
  return isUSDaylightSavingTime()
    ? time + 15 * 60 * 60 * 1000
    : time + 16 * 60 * 60 * 1000;
}

export function getTimeToLA(time) {
  return isUSDaylightSavingTime(time)
    ? time - 15 * 60 * 60 * 1000
    : time - 16 * 60 * 60 * 1000;
}

export function getLaToZero(time, diff) {
  const date = time.getTime() + diff * 60 * 60 * 1000;
  const dateZero = new Date(
    isUSDaylightSavingTime()
      ? date + 7 * 60 * 60 * 1000
      : date + 8 * 60 * 60 * 1000
  );
  return `${dateZero.getFullYear()}-${(dateZero.getMonth() + 1)
    .toString()
    .padStart(2, "0")}-${dateZero.getDate()}T${dateZero
    .getHours()
    .toString()
    .padStart(2, "0")}:00:00+0000`;
}
